import { showRendererStartupError } from "./app/bootstrap/renderer-visibility";

declare const __TARGET__: "electron" | "web";
declare const __APP_VERSION__: string;

if (typeof document !== "undefined") {
  const versionElement = document.getElementById("appVersion");
  if (versionElement) {
    versionElement.textContent = __APP_VERSION__;
  }
}

const targetEntry = __TARGET__ === "electron" ? import("./entry-electron") : import("./entry-web");

targetEntry.catch((error) => {
  showRendererStartupError();
  try {
    console.error(`[FlowTruss Analyze] ${__TARGET__} renderer entry failed`, error);
  } catch {
    // Console access may be unavailable during renderer teardown.
  }
});
